import { AmbassadorError, ServerStatus } from '@/models/globalModels';
import { TaxContext, TaxReducerPropsType } from '@/models/taxModels';

import * as t from '../types';

const globalState: TaxReducerPropsType = {
  taxContext: undefined,
  taxContextStatus: ServerStatus.IDLE,
  taxContextError: undefined,
};

export type PossibleActions =
  | { type: 'GET_TAX_CONTEXT_FETCHING' }
  | { type: 'GET_TAX_CONTEXT_FETCH'; payload: TaxContext }
  | { type: 'GET_TAX_CONTEXT_FETCH_ERROR'; payload: AmbassadorError }
  | { type: 'RESET_TAX_CONTEXT' };

const reducer = (state = globalState, action: PossibleActions): TaxReducerPropsType => {
  switch (action.type) {
    case t.GET_TAX_CONTEXT_FETCHING:
      return {
        ...state,
        taxContextStatus: ServerStatus.FETCHING,
        taxContextError: undefined,
      };
    case t.GET_TAX_CONTEXT_FETCH:
      return {
        ...state,
        taxContextStatus: ServerStatus.FETCH,
        taxContext: action.payload,
        taxContextError: undefined,
      };
    case t.GET_TAX_CONTEXT_FETCH_ERROR:
      return {
        ...state,
        taxContextStatus: ServerStatus.FETCH_ERROR,
        taxContextError: action.payload,
      };
    case t.RESET_TAX_CONTEXT:
      return globalState;
    default:
      return state;
  }
};

export default reducer;
